import React from "react";
import { Card, Button } from "react-bootstrap";
import { ActionHandlerFunction } from "@preveil-api";
import { AdminUIActionTypes, DefaultRoutes } from "src/common";
import { Icon } from "src/components";

type AllProps = {
  handleAction: ActionHandlerFunction;
}

// Description: If there are no addresses in the list, this component will be displayed.
// It will show a message to the user and a button to add addresses to the list.
function NoAddressesViewComponent(props: AllProps) {
  const { handleAction } = props;

  return <Card className="admin-card mt-4">
    <Icon className="email-gateway" />
    <Card.Body>
      <Card.Title as="p">Create a list of external addresses</Card.Title>
      <Card.Text as="p" className="create-list-text">
        <span className="text-muted">Learn More:</span>&nbsp;
        <a href={`${DefaultRoutes.remote_webapp_url}/support`}>preveil.com/support</a>
      </Card.Text>
      <Button variant="primary" onClick={() => handleAction({ actionType: AdminUIActionTypes.ShowModal })}>
        <Icon className="icon-plus2" />
        Add to Email Gateway List
      </Button>
    </Card.Body>
  </Card >;
}

export default React.memo(NoAddressesViewComponent);
